__turbopack_context__.v({
  "container": "ErNQDW_container",
  "headingText": "ErNQDW_headingText",
  "productGrid": "ErNQDW_productGrid",
  "skeletonCard": "ErNQDW_skeletonCard",
});
